export const CRM_MAX_FILE_MB = 25;
export const CRM_MAX_VIDEO_MB = 100;

const ALLOWED = new Set([
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv', 'rtf', 'odt', 'ods',
  'jpg', 'jpeg', 'png', 'gif', 'webp', 'svg',
  'zip', 'rar', '7z',
  'mp4', 'mov', 'avi', 'mkv', 'webm',
]);
const VIDEO = new Set(['mp4', 'mov', 'avi', 'mkv', 'webm']);

export const CRM_ACCEPT_ATTR = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.rtf,.odt,.ods,.jpg,.jpeg,.png,.gif,.webp,.svg,.zip,.rar,.7z,.mp4,.mov,.avi,.mkv,.webm';

const extensionOf = (name: string) => (name.includes('.') ? name.split('.').pop()!.toLowerCase() : '');

export const isCrmVideo = (name: string) => VIDEO.has(extensionOf(name));

/** Returns an i18n key (FileTypeNotAllowed | FileTooLarge | FileEmpty) or null when acceptable. */
export const validateCrmFile = (file: File): string | null => {
  if (file.size <= 0) return 'FileEmpty';
  if (!ALLOWED.has(extensionOf(file.name))) return 'FileTypeNotAllowed';
  const limitMb = isCrmVideo(file.name) ? CRM_MAX_VIDEO_MB : CRM_MAX_FILE_MB;
  return file.size / 1024 / 1024 > limitMb ? 'FileTooLarge' : null;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};
